import { AdminAPI } from "@shared/types/api";
import { ROLE_CONFIG } from "./roleConfig";

// Small inline icon indicating a user's staff role.
export function RoleBadge({
  role,
  className = "w-4 h-4",
}: {
  role: AdminAPI.UserRole;
  className?: string;
}) {
  const config = ROLE_CONFIG[role];
  const Icon = config.icon;
  return (
    <span title={`${config.label} role`} className="inline-flex items-center">
      <Icon className={`${className} ${config.className}`} />
    </span>
  );
}
